import React from "react";
import * as Sentry from "@sentry/react";
import Layout from "../layouts/index";
import OurStory from "../screens/Info/OurStory";

const OurStoryPage = () => {
  return (
    <Layout>
      <OurStory />
    </Layout>
  );
};

export default OurStoryPage;
